import AptisCard from "components/Aptis/AptisCard";
import CarruselHorizontal from "components/Carrusel/CarruselHorizontal";
import Contactanos from "components/Contactanos/Contactanos";
import Header from "components/Header";
import WhyCard from "components/Toefl/WhyCard";
// import ScrollTo from "hooks/ScrollTo";
import React from "react";
// import { Link } from "react-router-dom/cjs/react-router-dom.min";

const Toefl = () => {
  const whyChoseUs = [
    {
      title: "Autorización ETS Oficial",
      reason:
        "Somos un centro certificado por ETS en Pasto. Tu examen cuenta con respaldo internacional.",
    },
    {
      title: "Instalaciones Certificadas",
      reason: "Equipos modernos y espacios diseñados según estándares de ETS.",
    },
    {
      title: "Resultados Confiables",
      reason:
        "Certificación válida en más de 11,000 universidades y agencias en 160 países.",
    },
  ];
  const steps = [
    {
      num: "1. Regístrate",
      description:
        "Agenda tu fecha en línea o visítanos. Te guiamos en cada paso del proceso.",
    },
    {
      num: " 2. Prepárate",
      description:
        "Accede a recursos oficiales ETS y nuestro apoyo especializado.",
    },
    {
      num: "3. Preséntalo",
      description:
        "Realiza tu examen en nuestras instalaciones certificadas con personal capacitado.",
    },
    {
      num: "4. Recibe Tus Resultados",
      description: "Obtén tu certificación oficial entre 6 a 10 días hábiles.",
    },
  ];
  return (
    <>
      <Header
        titulo="TOEFL iBT - Brighton Centro de inglés autorizado"
        classTitulo="text-7xl font-Bebas font-bold text-[#ebff84]"
        info="Certifica tu nivel de inglés con Brighton, centro autorizado por ETS en Pasto para tu examen TOEFL oficial."
        // info="TOEFL es uno de los exámenes de inglés más
        //     reconocidos a nivel mundial, ideal para aquellos que buscan acceder
        //     a becas internacionales o ingresar a programas académicos de
        //     pregrado, posgrado, maestría o doctorado."
        linkToSection="/certificaciones/toefl#registrate"
        botonDescripcion="Agenda tu examen ahora"
        classBoton="bg-[#353579] text-[#ebff84] hover:bg-blue-800"
        img="https://brightonenglishcenter.edu.co/img/Header_Toefl.jpg"
      />
      <section id="info" className="w-full flex flex-col px-32 gap-10 my-32">
        <div className="flex flex-row items-center justify-center gap-10">
          <div className="w-1/2 h-[100vh] overflow-hidden rounded-30 group">
            <img
              width={1920}
              className="w-full h-full object-cover group-hover:scale-110 transition-all duration-300 ease-in-out"
              src="https://brightonenglishcenter.edu.co/img/RUG_3022.jpg"
              alt="Examen IELTS - Brighton Centro de Inglés"
            />
          </div>
          <div className="w-1/2 hyphens-none text-2xl space-y-5">
            <h2 className="text-6xl text-[#353579] font-bold font-Bebas">
              Tu Pasaporte Académico Internacional
            </h2>
            <p className="">
              El examen <strong>TOEFL IBT</strong> está diseñado para evaluar
              tus habilidades lingüísticas en un entorno académico. Es la prueba
              perfecta si aspiras a{" "}
              <em>
                <strong>estudiar</strong> en el extranjero, solicitar{" "}
                <strong>becas</strong> internacionales, avanzar en tus estudios
                de <strong>pregrado, posgrado o doctorado</strong>.
              </em>{" "}
              Aunque no tiene un puntaje mínimo definido para aprobar, las
              universidades e institutos establecen sus propios criterios de
              puntuación para admitir estudiantes, generalmente requiriendo un
              nivel mínimo de <strong>B2</strong> o superior.
            </p>
          </div>
        </div>
      </section>
      <section>
        <div className="m-32 flex flex-row items-center gap-5">
          <div className="w-1/2 columns-2 gap-4 space-y-4">
            <img
              className="w-full h-[400px] object-cover rounded-lg"
              src="https://brightonenglishcenter.edu.co/img/RUG_5140.jpg"
              alt=""
            />
            <img
              className="h-[200px] w-full object-cover object-bottom rounded-lg"
              src="https://images.pexels.com/photos/5505451/pexels-photo-5505451.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt=""
            />
            <img
              className="h-[200px] w-full object-cover rounded-lg"
              src="https://images.pexels.com/photos/7235807/pexels-photo-7235807.jpeg?auto=compress&cs=tinysrgb&w=600"
              alt=""
            />
            <img
              className="h-[400px] w-full object-cover rounded-lg"
              src="https://brightonenglishcenter.edu.co/img/Instalaciones.jpg"
              alt=""
            />
          </div>
          <div className="w-1/2 flex flex-col gap-8 ">
            <h2 className="text-6xl font-Bebas text-[#353579] font-bold">
              ¿POR QUÉ BRIGHTON?
            </h2>
            <p className="text-2xl hyphens-none">
              Brighton es tu aliado autorizado por ETS para realizar tu examen
              TOEFL. Como centro oficial, garantizamos procesos certificados,
              instalaciones aprobadas y resultados reconocidos mundialmente.
            </p>
            {whyChoseUs.map((value, index) => (
              <WhyCard key={index} title={value.title} info={value.reason} />
            ))}
          </div>
        </div>
      </section>
      <section className="m-32">
        <div className="w-full flex flex-row justify-center items-start">
          <div className="w-1/2 space-y-4 relative mb-40">
            {steps.map((o, i) => (
              <div
                key={i}
                className={` sticky w-max top-1/4 transform -translate-y-1/3 transition-all duration-500`}
                style={{
                  // left: `${i * 30}px`,
                  transform: `translateY(${i * 20}px) translateX(${i * 20}px)`,
                  zIndex: i + 1,
                }}
              >
                <div className="p-10 bg-[#ebff84]  w-[400px] h-[300px] flex flex-col gap-10 justify-between rounded-lg">
                  <span className="text-5xl font-bold text-[#353579] font-Bebas">
                    {o.num}
                  </span>
                  <p className="text-2xl text-[#353579]">{o.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="w-1/2 sticky top-1/3 h-full">
            <h2 className="font-Bebas text-6xl text-[#353579] font-bold">
              Presentar tu examen TOEFL es Simple
            </h2>
          </div>
        </div>
        <h3 id="registrate" className="uppercase text-5xl font-Bebas mt-32 mb-10 text-[#353579] font-bold">Regístrate Aquí</h3>
        <div className="w-full overflow-hidden rounded-lg rounded-tl-none shadow-[-10px_10px_0px_0px_#ebff84]">
          <a
            href="https://idaas.ets.org/u/login?state=hKFo2SBudWg4M3JUTU4yWjBwOF9BTjFsNXFhWXFMbnVlaU1IQ6Fur3VuaXZlcnNhbC1sb2dpbqN0aWTZIHVIaXV1ajgzejEzUENmN0Zmc2hBUHFXTWYyUGw4VFZxo2NpZNkgczM5NXo5OVR2R2RXeE5uaGJGRkt4ZGtkQzIxNUVwcGc&ui_locales=en"
            target="_blank"
          >
            <img
              src="https://brightonenglishcenter.edu.co/img/toefl-banner.webp"
              alt="Registrate y presenta tu examen toefl ibt"
              className="object-cover w-full h-full"
            />
          </a>
        </div>
      </section>
      <section>
        <div className=" p-32 bg-[#353579]">
          <h2 className="text-8xl uppercase font-bold font-Bebas text-center text-[#ebff84] tracking-wide">
            Curso de Preparación
          </h2>
        </div>
        <div className="h-[90vh]">
          <img
            className="object-cover w-full h-full"
            src="https://brightonenglishcenter.edu.co/img/grado_2024.webp"
            alt="Brighton Centro TOEFL autorizado en Pasto"
          />
        </div>
      </section>
      <section className="m-32 flex flex-col gap-10">
        <div className="flex flex-row gap-10">
          <div className="w-1/2">
            <h3 className="text-6xl font-bold font-Bebas text-right text-[#353579]">
              Preparación Completa para TOEFL iBT
            </h3>
          </div>
          <div className="w-1/2 text-2xl hyphens-none">
            <p>
              En <strong>Brighton</strong>, hemos desarrollado un curso de
              preparación completo para <strong>TOEFL iBT</strong>, diseñado
              para maximizar tu rendimiento en el examen. Nuestro curso incluye{" "}
              <em>
                formación grupal con un número limitado de candidatos o
                formación individual, asegurando una atención personalizada.
              </em>
            </p>
          </div>
        </div>
        <div className="space-y-10 pt-32">
          <h3 className="text-5xl font-Bebas font-bold text-[#353579]">
            Elige tu Modalidad
          </h3>
          <div className="flex flex-row gap-10">
            <div className="w-1/2 bg-[#353579] text-white p-5 space-y-5 rounded-lg rounded-tl-none shadow-[-10px_10px_0px_0px_#ebff84]">
              <span className="text-3xl leading-relaxed font-Bebas font-bold text-[#ebff84]">
                Formación Grupal
              </span>

              <ul class="space-y-4 text-left text-body">
                <li class="flex items-center space-x-3 rtl:space-x-reverse">
                  <svg
                    className="w-8 h-8 text-fg-success shrink-0 me-1.5 text-[#ebff84] "
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                  <span>3 días por semana</span>
                </li>
                <li class="flex items-center space-x-3 rtl:space-x-reverse">
                  <svg
                    className="w-8 h-8 text-fg-success shrink-0 me-1.5 text-[#ebff84] "
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                  <span>24 horas mensuales</span>
                </li>
                <li class="flex items-center space-x-3 rtl:space-x-reverse">
                  <svg
                    className="w-8 h-8 text-fg-success shrink-0 me-1.5 text-[#ebff84] "
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                  <span>Grupos reducidos para atención personalizada</span>
                </li>
                <li class="flex items-center space-x-3 rtl:space-x-reverse">
                  <svg
                    className="w-8 h-8 text-fg-success shrink-0 me-1.5 text-[#ebff84] "
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                  <span>Interacción con otros candidatos</span>
                </li>
              </ul>
            </div>
            <div className="w-1/2 bg-[#353579] text-white p-5 space-y-5 rounded-lg rounded-tl-none shadow-[-10px_10px_0px_0px_#ebff84]">
              <span className="text-3xl leading-relaxed font-Bebas font-bold text-[#ebff84]">
                Formación Individual
              </span>

              <ul class="space-y-4 text-left text-body">
                <li class="flex items-center space-x-3 rtl:space-x-reverse">
                  <svg
                    className="w-8 h-8 text-fg-success shrink-0 me-1.5 text-[#ebff84] "
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                  <span>3 días por semana</span>
                </li>
                <li class="flex items-center space-x-3 rtl:space-x-reverse">
                  <svg
                    className="w-8 h-8 text-fg-success shrink-0 me-1.5 text-[#ebff84] "
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                  <span>24 horas mensuales</span>
                </li>
                <li class="flex items-center space-x-3 rtl:space-x-reverse">
                  <svg
                    className="w-8 h-8 text-fg-success shrink-0 me-1.5 text-[#ebff84] "
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                  <span>Grupos reducidos para atención personalizada</span>
                </li>
                <li class="flex items-center space-x-3 rtl:space-x-reverse">
                  <svg
                    className="w-8 h-8 text-fg-success shrink-0 me-1.5 text-[#ebff84] "
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                  <span>Interacción con otros candidatos</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className=" bg-[#353579] space-y-20">
        <div className=" p-32 space-y-5 h-[50vh]">
          <h3 className="text-6xl font-Bebas font-bold text-[#ebff84]">
            Metodologia del curso
          </h3>
          <p className="text-2xl text-white">
            <em>
              Nuestra metodología se basa en conocer la estructura del examen y
              mostrarte las estrategias que podrías implementar y que se adapten
              a tu forma de enfrentar un examen.
            </em>
          </p>
        </div>
        <CarruselHorizontal outputA="40%" outputB="-50%">
          <div className="p-5 bg-[#ebff84] flex flex-col items-center rounded-lg rounded-tl-none w-[450px]">
            <svg
              className="fill-[#353579]"
              width={150}
              height={150}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 640"
            >
              <path d="M353.8 118.1L330.2 70.3C326.3 62 314.1 61.7 309.8 70.3L286.2 118.1L233.9 125.6C224.6 127 220.6 138.5 227.5 145.4L265.5 182.4L256.5 234.5C255.1 243.8 264.7 251 273.3 246.7L320.2 221.9L366.8 246.3C375.4 250.6 385.1 243.4 383.6 234.1L374.6 182L412.6 145.4C419.4 138.6 415.5 127.1 406.2 125.6L353.9 118.1zM288 320C261.5 320 240 341.5 240 368L240 528C240 554.5 261.5 576 288 576L352 576C378.5 576 400 554.5 400 528L400 368C400 341.5 378.5 320 352 320L288 320zM80 384C53.5 384 32 405.5 32 432L32 528C32 554.5 53.5 576 80 576L144 576C170.5 576 192 554.5 192 528L192 432C192 405.5 170.5 384 144 384L80 384zM448 496L448 528C448 554.5 469.5 576 496 576L560 576C586.5 576 608 554.5 608 528L608 496C608 469.5 586.5 448 560 448L496 448C469.5 448 448 469.5 448 496z" />
            </svg>
            <p className="text-xl hyphens-none text-center">
              Mejorar tus habilidades lingüísticas de manera efectiva en
              contextos académicos.
            </p>
          </div>
          <div className="p-5 bg-[#ebff84] flex flex-col items-center rounded-lg rounded-tl-none w-[450px]">
            <svg
              className="fill-[#353579]"
              width={150}
              height={150}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 640"
            >
              <path d="M320 216C368.6 216 408 176.6 408 128C408 79.4 368.6 40 320 40C271.4 40 232 79.4 232 128C232 176.6 271.4 216 320 216zM320 514.7L320 365.4C336.3 358.6 352.9 351.7 369.7 344.7C408.7 328.5 450.5 320.1 492.8 320.1L512 320.1L512 480.1L492.8 480.1C433.7 480.1 375.1 491.8 320.5 514.6L320 514.8zM320 296L294.9 285.5C248.1 266 197.9 256 147.2 256L112 256C85.5 256 64 277.5 64 304L64 496C64 522.5 85.5 544 112 544L147.2 544C197.9 544 248.1 554 294.9 573.5L307.7 578.8C315.6 582.1 324.4 582.1 332.3 578.8L345.1 573.5C391.9 554 442.1 544 492.8 544L528 544C554.5 544 576 522.5 576 496L576 304C576 277.5 554.5 256 528 256L492.8 256C442.1 256 391.9 266 345.1 285.5L320 296z" />
            </svg>
            <p className="text-xl hyphens-none text-center">
              Material didáctico actualizado.
            </p>
          </div>
          <div className="p-5 bg-[#ebff84] flex flex-col items-center rounded-lg rounded-tl-none w-[450px]">
            <svg
              className="fill-[#353579]"
              width={150}
              height={150}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 640"
            >
              <path d="M264.5 64C251.2 64 240.5 74.7 240.5 88C240.5 101.3 251.2 112 264.5 112L296.5 112L296.5 137.3C188.5 149.2 104.5 240.8 104.5 352C104.5 471.3 201.2 568 320.5 568C439.8 568 536.5 471.3 536.5 352C536.5 312.2 525.7 274.9 506.9 242.8L535.1 214.6C547.6 202.1 547.6 181.8 535.1 169.3C522.6 156.8 502.3 156.8 489.8 169.3L466.4 192.7C433.5 162.5 391.2 142.4 344.4 137.2L344.4 111.9L376.4 111.9C389.7 111.9 400.4 101.2 400.4 87.9C400.4 74.6 389.7 63.9 376.4 63.9L264.4 63.9zM204.5 304C204.5 275.3 227.8 252 256.5 252C285.2 252 308.5 275.3 308.5 304L308.5 307.8C308.5 319.5 305.3 330.9 299.2 340.8L255.4 412L288.5 412C299.5 412 308.5 421 308.5 432C308.5 443 299.5 452 288.5 452L230.7 452C216.2 452 204.5 440.3 204.5 425.8C204.5 420.9 205.8 416.2 208.4 412L265.1 319.9C267.3 316.3 268.5 312.1 268.5 307.8L268.5 304C268.5 297.4 263.1 292 256.5 292C249.9 292 244.5 297.4 244.5 304C244.5 315 235.5 324 224.5 324C213.5 324 204.5 315 204.5 304zM384.5 252C413.2 252 436.5 275.3 436.5 304L436.5 400C436.5 428.7 413.2 452 384.5 452C355.8 452 332.5 428.7 332.5 400L332.5 304C332.5 275.3 355.8 252 384.5 252zM372.5 304L372.5 400C372.5 406.6 377.9 412 384.5 412C391.1 412 396.5 406.6 396.5 400L396.5 304C396.5 297.4 391.1 292 384.5 292C377.9 292 372.5 297.4 372.5 304z" />
            </svg>
            <p className="text-xl hyphens-none text-center">
              Simulacros del examen que te familiarizan con el formato y las
              exigencias de TOEFL.
            </p>
          </div>
        </CarruselHorizontal>
      </section>
      <section className="m-32">
        <div className=" space-y-10 ">
          <h3 className="text-6xl font-Bebas font-bold text-[#ebff84]">
            Requisitos para iniciar tu entrenamiento
          </h3>
          <div className="flex flex-row justify-center gap-20">
            <div className="w-1/2 flex flex-row text-left items-center gap-5 p-5 text-white bg-[#353579] rounded-lg rounded-tl-none shadow-[-10px_10px_0px_0px_#ebff84] ">
              <i class="fa-solid fa-ranking-star text-9xl text-white"></i>
              <p className="text-base hyphens-none">
                <em>
                  Para inscribirte en el curso de preparación para el examen{" "}
                  <strong>TOEFL</strong>
                </em>
                , depende del puntaje final que debas obtener. Por ejemplo, si
                buscas obtener una <strong>banda C1</strong>, es recomendable
                tener un nivel{" "}
                <em>
                  <strong>intermedio-alto (B2+)</strong>
                </em>{" "}
                de inglés.
              </p>
            </div>
            <div className="w-1/2 flex flex-row text-left items-center text-white gap-5 p-5 bg-[#353579] rounded-lg rounded-tl-none shadow-[-10px_10px_0px_0px_#ebff84]">
              <i class="fa-solid fa-file-circle-check text-9xl text-white"></i>
              <p className="text-base hyphens-auto">
                <em>
                  Realizar un <strong>examen de diagnóstico</strong> previo para
                  ajustar el curso a tus necesidades específicas.
                </em>
              </p>
            </div>
          </div>
        </div>
      </section>
      <Contactanos
        classContainer="flex-row"
        titulo="Presenta tu examen TOEFL iBT con Brighton "
        classTitulo="text-[#ebff84]"
        texto="No dejes pasar la oportunidad de certificar tu nivel de inglés y abrirte a nuevas oportunidades académicas a nivel global. Inscríbete en nuestro curso de preparación para el TOEFL y comienza tu camino hacia el éxito académico. ¡Contáctanos hoy y da el primer paso hacia tu futuro con Brighton!"
        link="https://wa.link/ll8590"
        boton="Escribenos"
        classBoton="bg-[#353579] text-[#ebff84] hover:bg-blue-800"
        img="https://images.pexels.com/photos/3380743/pexels-photo-3380743.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
      />
    </>
  );
};

export default Toefl;
